import React from 'react'
import { Header, Form, Button } from 'semantic-ui-react'
import { Modal } from 'react-bootstrap'

const DeleteSourceUser = ({ mergeData, updateMergeData, setPage }) => {
    const { sourceUser, targetUser, jobsToRemove, deleteSourceUser } = mergeData
    return (
        <div className="delete-source">
            <Header as="h4" color="red">
                {`${
                    sourceUser.email
                } is also a client account (${sourceUser.membership
                    .map((m) => m.teamName)
                    .join(', ')}).`}
            </Header>
            <Header as="h4">
                {`Do you want to keep the account "${sourceUser.email}" after merging the expert data into the account "${targetUser.email}"?`}
            </Header>
            <Form>
                <Form.Radio
                    label={`Yes, keep the user account of ${sourceUser.email} for client user`}
                    checked={!deleteSourceUser}
                    onChange={() =>
                        updateMergeData({ deleteSourceUser: false })
                    }
                />
                <Form.Radio
                    label={`No, delete the user account of ${sourceUser.email}`}
                    checked={deleteSourceUser}
                    onChange={() => updateMergeData({ deleteSourceUser: true })}
                />
            </Form>
            <Modal.Footer>
                <Button
                    content="Back"
                    onClick={() =>
                        setPage(
                            jobsToRemove.length > 0
                                ? 'JOB_CONFLICTS'
                                : 'PREVIEW'
                        )
                    }
                />
                <Button
                    primary
                    content="Next"
                    onClick={() => setPage('CONFIRM')}
                />
            </Modal.Footer>
        </div>
    )
}

export default DeleteSourceUser
